export const bankCurrencyMap = {
  XPF: "EUR"
} as const;
